/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { DdApplicationReqDTO, DdApplicationRespDTO, DdSignReqDTO, DdSignRespDTO, LoginData, LoginReqDTO, LogoutReqDTO, Results, Result, DingTalkController, LoginController, LogoutController, ServiceHandler } from './types'
import $http from '../request'
import { AxiosRequestConfig } from 'axios'
import { BaseRequestDTO } from '../types'

export * from './types'

const basePath = ''

export const dingTalkController: DingTalkController = {

  async getSign(req: DdSignReqDTO, axiosConfig?: AxiosRequestConfig): Promise<Result<DdSignRespDTO>> {
    const path = `${basePath}/management/login-authentication/dingTalk/getSign`
    const payload: DdSignReqDTO = req
    const ret = await $http.run<DdSignReqDTO, Result<DdSignRespDTO>>(path, 'POST', payload, axiosConfig)
    return ret
  }
}

export const loginController: LoginController = {

  async authentication(req: LoginReqDTO, axiosConfig?: AxiosRequestConfig): Promise<Results<string, LoginData>> {
    const path = `${basePath}/management/login-authentication/login/authentication`
    const payload: LoginReqDTO = req
    const ret = await $http.run<LoginReqDTO, Results<string, LoginData>>(path, 'POST', payload, axiosConfig)
    return ret
  },

  async getDingApplicationInfo(req: DdApplicationReqDTO, axiosConfig?: AxiosRequestConfig): Promise<Result<DdApplicationRespDTO>> {
    const path = `${basePath}/management/login-authentication/login/getDingApplicationInfo`
    const payload: DdApplicationReqDTO = req
    const ret = await $http.run<DdApplicationReqDTO, Result<DdApplicationRespDTO>>(path, 'POST', payload, axiosConfig)
    return ret
  }
}

export const logoutController: LogoutController = {

  async authentication_1(req: LogoutReqDTO, axiosConfig?: AxiosRequestConfig): Promise<Result<string>> {
    const path = `${basePath}/management/login-authentication/logout/authentication`
    const payload: LogoutReqDTO = req
    const ret = await $http.run<LogoutReqDTO, Result<string>>(path, 'POST', payload, axiosConfig)
    return ret
  }
}
export const serviceHandler: ServiceHandler = {
  DingTalkController: dingTalkController,
  LoginController: loginController,
  LogoutController: logoutController
}
